import { render, staticRenderFns } from "./PlayAsTeamSetUp.vue?vue&type=template&id=e0b211ca&scoped=true"
import script from "./PlayAsTeamSetUp.vue?vue&type=script&lang=js"
export * from "./PlayAsTeamSetUp.vue?vue&type=script&lang=js"
import style0 from "./PlayAsTeamSetUp.vue?vue&type=style&index=0&id=e0b211ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b211ca",
  null
  
)

export default component.exports